import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isMobileView } from 'constants/isMobileView';
import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { CFHeader } from './components/CFHeader';
import CFTabPanels from './components/CFTabPanels';
import TimelineGraphSection from './timelineGraph/TimelineGraphSection';

const LevelUpCF = () => {
  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: 'FeedbackLandingPage',
      },
    });
  }, []);
  return (
    <div>
      {!checkNewNavEnabled() && <CFHeader />}
      <Box px={checkNewNavEnabled() ? 0 : 4} mt={4}>
        {!isMobileView() && !checkNewNavEnabled() && <TimelineGraphSection />}
        <PaperWithShadow borderRadius="8px">
          <CFTabPanels />
        </PaperWithShadow>
      </Box>
    </div>
  );
};

export { LevelUpCF };
